var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 278,
    height: 45,
    viewBox: "0 0 278 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 278,
    height: 45,
    fill: "url(#paint0_linear_12682_3533)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12682_3533",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 278,
    height: 45
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 278,
    height: 45,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12682_3533)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0 1C4.63333 1.05 9.26667 1.0975 13.9 1.1425C55.6 1.5475 97.3 1.75 139 1.75C180.7 1.75 222.4 1.5475 264.1 1.1425C268.733 1.0975 273.367 1.05 278 1C273.367 0.95 268.733 0.9025 264.1 0.8575C222.4 0.4525 180.7 0.25 139 0.25C97.3 0.25 55.6 0.4525 13.9 0.8575C9.26667 0.9025 4.63333 0.95 0 1Z",
    fill: "url(#paint1_linear_12682_3533)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_12682_3533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 1C46.5195 1.05 48.039 1.0975 49.5584 1.1425C63.2338 1.5475 76.9091 1.75 90.5844 1.75C104.26 1.75 117.935 1.5475 131.61 1.1425C133.13 1.0975 134.649 1.05 136.169 1C134.649 0.95 133.13 0.9025 131.61 0.8575C117.935 0.4525 104.26 0.25 90.5844 0.25C76.9091 0.25 63.2338 0.4525 49.5584 0.8575C48.039 0.9025 46.5195 0.95 45 1Z",
    fill: "url(#paint2_linear_12682_3533)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0 44C4.63333 44.05 9.26667 44.0975 13.9 44.1425C55.6 44.5475 97.3 44.75 139 44.75C180.7 44.75 222.4 44.5475 264.1 44.1425C268.733 44.0975 273.367 44.05 278 44C273.367 43.95 268.733 43.9025 264.1 43.8575C222.4 43.4525 180.7 43.25 139 43.25C97.3 43.25 55.6 43.4525 13.9 43.8575C9.26667 43.9025 4.63333 43.95 0 44Z",
    fill: "url(#paint3_linear_12682_3533)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_12682_3533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141 44C142.519 44.05 144.039 44.0975 145.558 44.1425C159.234 44.5475 172.909 44.75 186.584 44.75C200.26 44.75 213.935 44.5475 227.61 44.1425C229.13 44.0975 230.649 44.05 232.169 44C230.649 43.95 229.13 43.9025 227.61 43.8575C213.935 43.4525 200.26 43.25 186.584 43.25C172.909 43.25 159.234 43.4525 145.558 43.8575C144.039 43.9025 142.519 43.95 141 44Z",
    fill: "url(#paint4_linear_12682_3533)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_12682_3533",
    x: 43,
    y: -1.75,
    width: 95.1689,
    height: 5.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_12682_3533"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_12682_3533",
    x: 139,
    y: 41.25,
    width: 95.1689,
    height: 5.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_12682_3533"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12682_3533",
    x1: 0,
    y1: 22.5,
    x2: 278,
    y2: 22.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533661,
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12682_3533",
    x1: 21.672,
    y1: 1,
    x2: 277.997,
    y2: 2.11694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFBC37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12682_3533",
    x1: 45,
    y1: 1.5,
    x2: 136.169,
    y2: 1.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12682_3533",
    x1: 21.672,
    y1: 44,
    x2: 277.997,
    y2: 45.1169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFBC37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB800",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_12682_3533",
    x1: 141,
    y1: 44.5,
    x2: 232.169,
    y2: 44.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA600",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFFAE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA600",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardName);
export default __webpack_public_path__ + "static/media/reward-name.d35a80264a6fc06846fee353b494958d.svg";
export { ForwardRef as ReactComponent };